import { ItemService } from "services";
import { ResponseExceptionHandlerHelper, WarningException } from "utils";

export const ItemManager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();

  const listado = (where) => {
    return ItemService.listado(where).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res;
    });
  };


  const crear = (item) => {
    return validar(item).then(() =>
      ItemService.crear({
        ...item,
        Files: item.Img,
      }).then((res) => {
        if (!res.Success) {
          handleException(res);
        }
        return res.Data;
      })
    );
  };

  const actualizar = (item) => {
    return validar(item).then(() =>
      ItemService.actualizar({
        ...item,
        Files: item.Img,
      }).then((res) => {
        if (!res.Success) {
          handleException(res);
        }
        return res.Data;
      })
    );
  };

  const buscarPorId = (id) => {
    return ItemService.buscarPorId(id).then((res) => {
      if (!res.Success) {
        handleException(res);
      }
      return res.Data;
    });
  };

  const exportar = (where) => {
    console.log(where);
    return ItemService.exportar(where).then((res) => {
      return res;
    });
  };

  const validar = (item) => {
    return new Promise((res) => res(item)).then((item) => {
      let requiredFields = [];
      if (!item.Nombre) {
        requiredFields.push("Nombre");
      }

      if (!item.Descripcion) {
        requiredFields.push("Descripción");
      }

      if (item.IndicadorBienOServicio === undefined || item.IndicadorBienOServicio === null) {
        requiredFields.push("Tipo");
      }


      if (!item.IndicadorFacturacion === undefined || item.IndicadorFacturacion === null) {
        requiredFields.push("Tipo ITBIS");
      }

      if (requiredFields.length > 0) {
        throw new WarningException(
          `Los siguientes campos son requeridos: ${requiredFields.join(", ")}.`
        );
      }
    });
  };

  return { listado, crear, actualizar, buscarPorId, exportar };
})();